export var TaskType;
(function (TaskType) {
    TaskType["Blanks"] = "Blanks";
    TaskType["Sort"] = "Sort";
    TaskType["Poll"] = "Poll";
    TaskType["Grid"] = "Grid";
    TaskType["Prompt"] = "Prompt";
    TaskType["Multimedia"] = "Multimedia";
    TaskType["ImageReview"] = "ImageReview";
    TaskType["VideoReview"] = "VideoReview";
})(TaskType || (TaskType = {}));
export var BlankType;
(function (BlankType) {
    BlankType["CHOICE"] = "CHOICE";
    BlankType["SCALE"] = "SCALE";
    BlankType["SCALE_ALLOCATION"] = "SCALE_ALLOCATION";
})(BlankType || (BlankType = {}));
export var ResponseState;
(function (ResponseState) {
    ResponseState["Skipped"] = "Skipped";
    ResponseState["Complete"] = "Complete";
    ResponseState["Draft"] = "Draft";
    ResponseState["Rejected"] = "Rejected";
    ResponseState["None"] = "None";
})(ResponseState || (ResponseState = {}));
export var ActivityState;
(function (ActivityState) {
    ActivityState["Current"] = "Current";
    ActivityState["Upcoming"] = "Upcoming";
    ActivityState["Expired"] = "Expired";
    ActivityState["Archived"] = "Archived";
})(ActivityState || (ActivityState = {}));
export var SkipReason;
(function (SkipReason) {
    SkipReason["INCOMPLETE"] = "INCOMPLETE";
    SkipReason["ADMIN_EDIT"] = "ADMIN_EDIT";
    SkipReason["NOT_VISIBLE"] = "NOT_VISIBLE";
})(SkipReason || (SkipReason = {}));
